import toast from "react-hot-toast";
import axios from "../utils/axiosSetup";
import ILeadData from "../models/LeadData.model";

const fetchRoles = async () => {
  const response = await axios.get("/users/extractRoles");
  return response.data.data;
};

const updateAssignee = async (
  leadId: string,
  assigneeId: string
): Promise<ILeadData | undefined> => {
  try {
    const response = await axios.put(`/leads/updateAssignee`, {
      leadId: leadId,
      assigneeId: assigneeId,
    });
    toast.success("Assignee updated successfully.");
    return response?.data?.data;
  } catch (error: any) {
    if (error.response) {
      throw error;
    }
    return undefined;
  }
};

const bulkUpdateAssignee = async (
  leadIds: string[],
  assigneeId: string
): Promise<any> => {
  try {
    const response = await axios.put("/leads/updateBulkAssignee", {
      leadIds,
      assigneeId,
    });
    toast.success("Assignees updated successfully");
    return {
      username: response.data.data.username, 
    };
  } catch (error: any) {
    toast.error(error.response?.data?.message || "Failed to update assignees");
    throw error;
  }
};

export { fetchRoles, updateAssignee, bulkUpdateAssignee };
